<ng-container *ngFor="let entry of entryArray">
    <li (click)="scrollTo(entry.id)" class="level-{{entry.level}}">{{entry.text}}</li>
    <ng-container *ngIf="entry.children.length > 0">
        <app-table-of-content-list-recursive [entryArray]="entry.children"></app-table-of-content-list-recursive>
    </ng-container>
</ng-container>
